var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ul',{staticClass:"social-icons"},_vm._l((_vm.icons),function(icon){return _c('li',{key:icon.id,staticClass:"social-icon"},[_c('a',{attrs:{"target":"_blank","href":icon.link}},[_c('v-icon',{staticClass:"custom-icon",attrs:{"name":icon.icon}})],1)])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }